import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M12.0002 22C10.8957 22 10.0002 21.1046 10.0002 20H14.0002C14.0002 21.1046 13.1048 22 12.0002 22ZM19.5852 21.9L16.6852 19H4.00023V17L6.00023 16V10.5C5.99674 9.82904 6.05769 9.1593 6.18223 8.5L2.61523 4.929L4.02923 3.515L20.9982 20.487L19.5862 21.9H19.5852ZM17.9992 14.659L8.27923 4.938C8.79915 4.5776 9.38337 4.32028 10.0002 4.18V2H14.0002V4.18C16.5792 4.793 18.0002 7.038 18.0002 10.5V14.66L17.9992 14.659Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "NotificationDeactivated"
);
